export default function elementorPanels(editor) {
  const pn = editor.Panels
  const sm = editor.StyleManager
  const tm = editor.TraitManager

  pn.getPanels().reset()

  let currentView = 'widgets'

  pn.addPanel({ id: 'eb-canvas-toolbar', el: '.eb-canvas-toolbar' })
  pn.addPanel({ id: 'eb-sidebar-header', el: '.eb-sidebar-header' })
  pn.addPanel({ id: 'eb-sidebar-footer', el: '.eb-sidebar-footer' })

  pn.addButton('eb-canvas-toolbar', [
    { id: 'eb-undo', className: 'fa fa-undo', command: 'core:undo', attributes: { title: 'Undo' } },
    { id: 'eb-redo', className: 'fa fa-repeat', command: 'core:redo', attributes: { title: 'Redo' } },
  ])

  editor.Commands.add('core:open-code', {
    run(editor) {
      const html = editor.getHtml()
      const css = editor.getCss()
      const modal = editor.Modal
      modal.setTitle('Edit Code')
      modal.setContent(`
        <div style="display:flex;gap:10px;height:400px;">
          <div style="flex:1;display:flex;flex-direction:column;">
            <label style="font-weight:600;margin-bottom:4px;color:#ccc;font-size:12px;">HTML</label>
            <textarea id="eb-code-html" style="flex:1;font-family:monospace;font-size:13px;padding:10px;border:1px solid #444;border-radius:6px;background:#1e1e1e;color:#d4d4d4;resize:none;">${escapeHtml(html)}</textarea>
          </div>
          <div style="flex:1;display:flex;flex-direction:column;">
            <label style="font-weight:600;margin-bottom:4px;color:#ccc;font-size:12px;">CSS</label>
            <textarea id="eb-code-css" style="flex:1;font-family:monospace;font-size:13px;padding:10px;border:1px solid #444;border-radius:6px;background:#1e1e1e;color:#d4d4d4;resize:none;">${escapeHtml(css)}</textarea>
          </div>
        </div>
        <div style="text-align:right;margin-top:10px;">
          <button id="eb-code-apply" style="padding:8px 20px;background:#667eea;color:white;border:none;border-radius:6px;cursor:pointer;font-weight:600;">Apply</button>
        </div>
      `)
      modal.open()

      const applyBtn = document.getElementById('eb-code-apply')
      if (applyBtn) {
        applyBtn.onclick = () => {
          const newHtml = document.getElementById('eb-code-html').value
          const newCss = document.getElementById('eb-code-css').value
          editor.setComponents(newHtml)
          editor.setStyle(newCss)
          modal.close()
        }
      }
    },
  })

  function escapeHtml(str) {
    return (str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
  }

  function showWidgetsView() {
    currentView = 'widgets'
    const body = document.querySelector('.eb-sidebar-body')
    if (!body) return

    body.querySelectorAll('.eb-panel-view').forEach(v => v.style.display = 'none')

    let widgetsView = body.querySelector('.eb-widgets-view')
    if (!widgetsView) {
      widgetsView = document.createElement('div')
      widgetsView.className = 'eb-panel-view eb-widgets-view'

      const searchWrap = document.createElement('div')
      searchWrap.className = 'eb-search-wrap'
      searchWrap.innerHTML = '<i class="fa fa-search"></i><input type="text" class="eb-search-input" placeholder="Search Widget...">'
      widgetsView.appendChild(searchWrap)

      const blocksEl = document.createElement('div')
      blocksEl.className = 'eb-blocks-container'
      widgetsView.appendChild(blocksEl)

      body.appendChild(widgetsView)

      const bmRender = editor.BlockManager.render()
      blocksEl.appendChild(bmRender)

      const searchInput = searchWrap.querySelector('.eb-search-input')
      searchInput.addEventListener('input', (e) => {
        const query = e.target.value.toLowerCase()
        const blocks = blocksEl.querySelectorAll('.gjs-block')
        blocks.forEach(block => {
          const label = block.querySelector('.gjs-block-label')
          const text = label ? label.textContent.toLowerCase() : ''
          block.style.display = text.includes(query) || !query ? '' : 'none'
        })
        const cats = blocksEl.querySelectorAll('.gjs-block-category')
        cats.forEach(cat => {
          const visibleBlocks = cat.querySelectorAll('.gjs-block:not([style*="display: none"])')
          const title = cat.querySelector('.gjs-title')
          if (title) {
            cat.style.display = visibleBlocks.length || !query ? '' : 'none'
          }
        })
      })
    }

    widgetsView.style.display = 'block'
    updateHeader('widgets')
  }

  function buildAdvancedPanel() {
    const wrap = document.createElement('div')
    wrap.className = 'eb-adv-wrap'

    wrap.innerHTML = `
      <div class="eb-adv-section">
        <div class="eb-adv-section-title">Margin</div>
        <div class="eb-adv-spacing-grid">
          <div class="eb-adv-spacing-field">
            <input type="number" data-style="margin-top" placeholder="—" />
            <span>Top</span>
          </div>
          <div class="eb-adv-spacing-field">
            <input type="number" data-style="margin-right" placeholder="—" />
            <span>Right</span>
          </div>
          <div class="eb-adv-spacing-field">
            <input type="number" data-style="margin-bottom" placeholder="—" />
            <span>Bottom</span>
          </div>
          <div class="eb-adv-spacing-field">
            <input type="number" data-style="margin-left" placeholder="—" />
            <span>Left</span>
          </div>
        </div>
      </div>
      <div class="eb-adv-section">
        <div class="eb-adv-section-title">Padding</div>
        <div class="eb-adv-spacing-grid">
          <div class="eb-adv-spacing-field">
            <input type="number" data-style="padding-top" placeholder="—" />
            <span>Top</span>
          </div>
          <div class="eb-adv-spacing-field">
            <input type="number" data-style="padding-right" placeholder="—" />
            <span>Right</span>
          </div>
          <div class="eb-adv-spacing-field">
            <input type="number" data-style="padding-bottom" placeholder="—" />
            <span>Bottom</span>
          </div>
          <div class="eb-adv-spacing-field">
            <input type="number" data-style="padding-left" placeholder="—" />
            <span>Left</span>
          </div>
        </div>
      </div>
      <div class="eb-adv-section">
        <div class="eb-adv-section-title">Positioning</div>
        <div class="eb-adv-field-row">
          <label>Z-Index</label>
          <input type="number" data-style="z-index" placeholder="auto" class="eb-adv-input" />
        </div>
        <div class="eb-adv-field-row">
          <label>Overflow</label>
          <select data-style="overflow" class="eb-adv-select">
            <option value="">Default</option>
            <option value="visible">Visible</option>
            <option value="hidden">Hidden</option>
            <option value="scroll">Scroll</option>
            <option value="auto">Auto</option>
          </select>
        </div>
      </div>
      <div class="eb-adv-section">
        <div class="eb-adv-section-title">CSS Classes</div>
        <div class="eb-adv-field-row">
          <input type="text" class="eb-adv-input eb-adv-classes-input" placeholder="class1 class2..." />
        </div>
      </div>
      <div class="eb-adv-section">
        <div class="eb-adv-section-title">Custom CSS</div>
        <textarea class="eb-adv-css-editor" placeholder="selector { color: red; }&#10;selector:hover { opacity: 0.8; }"></textarea>
        <div class="eb-adv-css-hint">Use <code>selector</code> to target this element.</div>
      </div>
    `

    // Wire up spacing + positioning inputs
    wrap.querySelectorAll('[data-style]').forEach(input => {
      input.addEventListener('change', () => {
        const sel = editor.getSelected()
        if (!sel) return
        const prop = input.getAttribute('data-style')
        const val = input.value
        if (val === '' || val === null) {
          const style = { ...sel.getStyle() }
          delete style[prop]
          sel.setStyle(style)
        } else {
          const unit = prop === 'z-index' || prop === 'overflow' ? '' : 'px'
          sel.addStyle({ [prop]: val + unit })
        }
      })
    })

    // Wire up CSS Classes
    const classesInput = wrap.querySelector('.eb-adv-classes-input')
    classesInput.addEventListener('change', () => {
      const sel = editor.getSelected()
      if (!sel) return
      const classes = classesInput.value.trim().split(/\s+/).filter(Boolean)
      sel.getClasses().forEach(c => sel.removeClass(c))
      classes.forEach(c => sel.addClass(c))
    })

    // Wire up Custom CSS
    const cssEditor = wrap.querySelector('.eb-adv-css-editor')
    cssEditor.addEventListener('input', () => {
      const sel = editor.getSelected()
      if (!sel) return
      sel.set('custom-css', cssEditor.value)
    })

    // Update values when component is selected
    editor.on('component:selected', (component) => {
      const style = component.getStyle()
      wrap.querySelectorAll('[data-style]').forEach(input => {
        const prop = input.getAttribute('data-style')
        const rawVal = style[prop] || ''
        if (input.tagName === 'SELECT') {
          input.value = rawVal
        } else {
          input.value = parseInt(rawVal) || ''
        }
      })
      const classes = component.getClasses().join(' ')
      classesInput.value = classes
      cssEditor.value = component.get('custom-css') || ''
    })

    return wrap
  }

  function showEditView() {
    currentView = 'edit'
    const body = document.querySelector('.eb-sidebar-body')
    if (!body) return

    body.querySelectorAll('.eb-panel-view').forEach(v => v.style.display = 'none')

    let editView = body.querySelector('.eb-edit-view')
    if (!editView) {
      editView = document.createElement('div')
      editView.className = 'eb-panel-view eb-edit-view'

      const tabBar = document.createElement('div')
      tabBar.className = 'eb-edit-tabs'
      const tabs = [
        { id: 'content', label: 'Content', icon: 'fa-cog' },
        { id: 'style', label: 'Style', icon: 'fa-paint-brush' },
        { id: 'advanced', label: 'Advanced', icon: 'fa-sliders' },
      ]
      tabs.forEach((tab, i) => {
        const btn = document.createElement('button')
        btn.className = 'eb-edit-tab' + (i === 0 ? ' active' : '')
        btn.setAttribute('data-edit-tab', tab.id)
        btn.innerHTML = `<i class="fa ${tab.icon}"></i><span>${tab.label}</span>`
        btn.onclick = () => {
          tabBar.querySelectorAll('.eb-edit-tab').forEach(b => b.classList.remove('active'))
          btn.classList.add('active')
          editView.querySelectorAll('.eb-edit-tab-content').forEach(c => c.style.display = 'none')
          const panel = editView.querySelector(`[data-edit-panel="${tab.id}"]`)
          if (panel) panel.style.display = 'block'
        }
        tabBar.appendChild(btn)
      })
      editView.appendChild(tabBar)

      const contentPanel = document.createElement('div')
      contentPanel.className = 'eb-edit-tab-content'
      contentPanel.setAttribute('data-edit-panel', 'content')
      contentPanel.style.display = 'block'
      const tmEl = tm.render()
      contentPanel.appendChild(tmEl)
      editView.appendChild(contentPanel)

      const stylePanel = document.createElement('div')
      stylePanel.className = 'eb-edit-tab-content'
      stylePanel.setAttribute('data-edit-panel', 'style')
      stylePanel.style.display = 'none'
      const smEl = sm.render()
      stylePanel.appendChild(smEl)
      editView.appendChild(stylePanel)

      const advancedPanel = document.createElement('div')
      advancedPanel.className = 'eb-edit-tab-content'
      advancedPanel.setAttribute('data-edit-panel', 'advanced')
      advancedPanel.style.display = 'none'
      advancedPanel.appendChild(buildAdvancedPanel())
      editView.appendChild(advancedPanel)

      body.appendChild(editView)
    }

    editView.style.display = 'block'
    updateHeader('edit')
  }

  function updateHeader(view) {
    const header = document.querySelector('.eb-sidebar-header')
    if (!header) return
    header.innerHTML = ''

    if (view === 'widgets') {
      header.innerHTML = `
        <div class="eb-header-content">
          <span class="eb-header-title">Page Builder</span>
          <button class="eb-header-icon" id="eb-header-grid" title="Widget Grid"><i class="fa fa-th-large"></i></button>
        </div>
      `
    } else {
      const selected = editor.getSelected()
      const name = selected ? (selected.getName() || selected.get('type') || 'Element').replace('eb-', '').replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : 'Edit Element'

      header.innerHTML = `
        <div class="eb-header-content">
          <button class="eb-header-back" id="eb-header-back" title="Back to Widgets"><i class="fa fa-arrow-left"></i></button>
          <span class="eb-header-title">Edit ${escapeHtml(name)}</span>
          <button class="eb-header-icon" id="eb-header-grid2" title="Widget Grid"><i class="fa fa-th-large"></i></button>
        </div>
      `
      const backBtn = header.querySelector('#eb-header-back')
      if (backBtn) backBtn.onclick = () => showWidgetsView()
      const gridBtn = header.querySelector('#eb-header-grid2')
      if (gridBtn) gridBtn.onclick = () => showWidgetsView()
    }
  }

  function setupFooter() {
    const footer = document.querySelector('.eb-sidebar-footer')
    if (!footer) return

    const buttons = [
      { id: 'eb-ft-navigator', icon: 'fa-bars', label: 'Navigator', command: 'open-navigator' },
      { id: 'eb-ft-history', icon: 'fa-history', label: 'History', command: 'open-history' },
      { id: 'eb-ft-templates', icon: 'fa-clone', label: 'Templates', command: 'open-templates' },
      { id: 'eb-ft-theme', icon: 'fa-sliders', label: 'Theme', command: 'open-global-styles' },
      { id: 'eb-ft-code', icon: 'fa-code', label: 'Code', command: 'core:open-code' },
      { id: 'eb-ft-preview', icon: 'fa-eye', label: 'Preview', command: 'core:preview' },
    ]

    buttons.forEach(btn => {
      const el = document.createElement('button')
      el.className = 'eb-footer-btn'
      el.id = btn.id
      el.title = btn.label
      el.innerHTML = `<i class="fa ${btn.icon}"></i>`
      el.onclick = () => {
        if (btn.command === 'open-navigator' || btn.command === 'open-history' || btn.command === 'open-templates' || btn.command === 'open-global-styles') {
          const body = document.querySelector('.eb-sidebar-body')
          if (!body) return
          body.querySelectorAll('.eb-panel-view').forEach(v => v.style.display = 'none')
          currentView = btn.command
          updateHeader('widgets')
          editor.runCommand(btn.command)
        } else {
          editor.runCommand(btn.command)
        }
      }
      footer.appendChild(el)
    })
  }

  function setupCanvasToolbar() {
    const toolbar = document.querySelector('.eb-canvas-toolbar')
    if (!toolbar) return

    toolbar.innerHTML = `
      <div class="eb-toolbar-left">
        <button class="eb-tb-btn" id="eb-tb-undo" title="Undo"><i class="fa fa-undo"></i></button>
        <button class="eb-tb-btn" id="eb-tb-redo" title="Redo"><i class="fa fa-repeat"></i></button>
      </div>
      <div class="eb-toolbar-center">
        <div class="eb-device-group">
          <button class="eb-device-btn active" data-device="Desktop" title="Desktop"><i class="fa fa-desktop"></i></button>
          <button class="eb-device-btn" data-device="Tablet" title="Tablet"><i class="fa fa-tablet"></i></button>
          <button class="eb-device-btn" data-device="Mobile" title="Mobile"><i class="fa fa-mobile"></i></button>
        </div>
      </div>
      <div class="eb-toolbar-right">
        <button class="eb-tb-btn" id="eb-tb-code" title="View Code"><i class="fa fa-code"></i></button>
        <button class="eb-tb-btn" id="eb-tb-fullscreen" title="Fullscreen"><i class="fa fa-arrows-alt"></i></button>
        <button class="eb-tb-btn eb-tb-clear" id="eb-tb-clear" title="Clear Canvas"><i class="fa fa-trash"></i></button>
      </div>
    `

    toolbar.querySelector('#eb-tb-undo').onclick = () => editor.runCommand('core:undo')
    toolbar.querySelector('#eb-tb-redo').onclick = () => editor.runCommand('core:redo')
    toolbar.querySelector('#eb-tb-code').onclick = () => editor.runCommand('core:open-code')
    toolbar.querySelector('#eb-tb-fullscreen').onclick = () => editor.runCommand('core:fullscreen')
    toolbar.querySelector('#eb-tb-clear').onclick = () => editor.runCommand('core:canvas-clear')

    if (editor.emailMode) {
      const deviceGroup = toolbar.querySelector('.eb-device-group')
      if (deviceGroup) deviceGroup.style.display = 'none'
    } else {
      toolbar.querySelectorAll('.eb-device-btn').forEach(btn => {
        btn.onclick = () => {
          toolbar.querySelectorAll('.eb-device-btn').forEach(b => b.classList.remove('active'))
          btn.classList.add('active')
          editor.setDevice(btn.getAttribute('data-device'))
        }
      })
    }
  }

  editor.on('load', () => {
    setupCanvasToolbar()
    setupFooter()
    showWidgetsView()
  })

  editor.on('component:selected', () => {
    showEditView()
  })

  editor.on('component:deselected', () => {
    if (currentView === 'edit') {
      showWidgetsView()
    }
  })
}
